// global function start for slick slider
class ResponsiveSlick {
  constructor(selector, breakpoints) {
    this.selector = selector;
    this.breakpoints = breakpoints;
    this.init = false;

    // Track last "mode" so we only re-init when mode changes
    this.lastKey = null;

    // Debounce resize
    this._resizeTimer = null;

    // ✅ Prevent FOUC ONLY for cmpl-slider on mobile (<= 991.98px)
    if (this.selector === ".cmpl-slider" && window.matchMedia("(max-width: 991.98px)").matches) {
      $(this.selector).css("visibility", "hidden");
    }

    // Initial run
    this.slickCard();

    // Resize listener (debounced)
    window.addEventListener("resize", () => {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => {
        this.slickCard();
      }, 150);
    });
  }

  initSlick(options) {
    const $el = $(this.selector);

    // ✅ For cmpl-slider: only init on max-width 991.98px
    if (this.selector === ".cmpl-slider" && !window.matchMedia("(max-width: 991.98px)").matches) {
      $el.css("visibility", "visible");
      return;
    }

    // ✅ Avoid double init
    if ($el.hasClass("slick-initialized")) return;

    // ✅ For cmpl-slider: reveal only AFTER slick has initialized
    if (this.selector === ".cmpl-slider") {
      $el.off("init.cmplReveal");
      $el.on("init.cmplReveal", function () {
        $(this).css("visibility", "visible");
      });
    }

    $el.slick(options);

    // ✅ Apply 4-dot windowing ONLY to the cmpl-slider
    if (this.selector === ".cmpl-slider") {
      limitSlickDotsToWindow(this.selector, 4);
    }
  }

  destroySlick() {
    const $el = $(this.selector);

    if ($el.hasClass("slick-initialized")) {
      $el.slick("unslick");
    }

    // ✅ Ensure cmpl-slider is always visible on desktop; hidden only on mobile pre-init
    if (this.selector === ".cmpl-slider") {
      if (window.matchMedia("(max-width: 991.98px)").matches) {
        $el.css("visibility", "hidden");
      } else {
        $el.css("visibility", "visible");
      }
    }
  }

  getOptionsForWidth(width) {
    for (let breakpoint in this.breakpoints) {
      if (width <= breakpoint) {
        return this.breakpoints[breakpoint];
      }
    }
    return null;
  }

  // NEW: what "key" are we in? (used to avoid re-init spam)
  getActiveKey(width) {
    // For cmpl-slider we only care about mobile vs desktop
    if (this.selector === ".cmpl-slider") {
      return window.matchMedia("(max-width: 991.98px)").matches ? "mobile" : "desktop";
    }

    // For other sliders: choose the first matching breakpoint key
    for (let breakpoint in this.breakpoints) {
      if (width <= breakpoint) return String(breakpoint);
    }
    return "none";
  }

  slickCard() {
    const width = window.innerWidth;
    const $el = $(this.selector);

    const key = this.getActiveKey(width);
    const options = this.getOptionsForWidth(width);

    // ✅ Hard lock: cmpl-slider NEVER initializes at >= 992px
    if (this.selector === ".cmpl-slider" && key === "desktop") {
      if (this.init) {
        this.destroySlick();
        this.init = false;
      }
      this.lastKey = key;
      $el.css("visibility", "visible");
      return;
    }

    // ✅ If we're still in the same mode/breakpoint bucket, do nothing
    // (prevents unslick/reslick spam while resizing)
    if (this.lastKey === key) {
      // if already initialized and it's cmpl, keep dots window correct
      if (this.selector === ".cmpl-slider" && $el.hasClass("slick-initialized")) {
        limitSlickDotsToWindow(this.selector, 4);
      }
      return;
    }

    // Bucket changed
    this.lastKey = key;

    // If we have options (or cmpl mobile), ensure slick is on
    if (options) {
      // If was initialized, rebuild cleanly
      if (this.init) {
        this.destroySlick();
      }
      this.init = true;

      // Small delay lets layout settle after breakpoint switch
      setTimeout(() => {
        this.initSlick(options);
      }, 0);
      return;
    }

    // No options: ensure slick is off
    if (this.init) {
      this.destroySlick();
      this.init = false;
    }

    // Ensure visible when unslicked
    if (this.selector === ".cmpl-slider") {
      $el.css("visibility", "visible");
    }
  }
}
// global function end for slick slider


// global function end for slick slider

// ✅ Limit Slick dots to show only a fixed window (e.g., 4) at a time
// ✅ Limit Slick dots to a fixed window (e.g., 4) AND animate the shift
// Active dot becomes the LEFT-most visible dot with a smooth slide animation
function limitSlickDotsToWindow(selector, visibleCount) {
  const $slider = $(selector);
  if (!$slider.length) return;

  // Prevent duplicate bindings (important because ResponsiveSlick re-inits on resize)
  $slider.off("init.cmplDots afterChange.cmplDots");

  function ensureDotsViewport() {
    const $ul = $slider.find("ul.slick-dots");
    if (!$ul.length) return null;

    // Wrap the dots UL in a viewport (only once) so we can clip to 4 dots
    if (!$ul.parent().hasClass("cmpl-dots-viewport")) {
      $ul.wrap('<div class="cmpl-dots-viewport"></div>');
    }

    const $viewport = $ul.parent(".cmpl-dots-viewport");

    // Force a single-row dot layout (safe even if you already have CSS)
    $ul.css({
      display: "flex",
      flexWrap: "nowrap",
      gap: "8px",
      padding: 0,
      margin: 0,
      listStyle: "none",
      width: "max-content",
      transform: "translateX(0px)",
      transition: "transform 240ms ease",
      willChange: "transform",
    });

    // Ensure dots don't wrap and have stable sizing
    $ul.find("li").css({ flex: "0 0 auto" });

    // Viewport clips the UL so only 4 dots appear
    $viewport.css({
      maxWidth: "100px", // fallback; we’ll overwrite below with exact width
      overflow: "hidden",
      margin: "0 auto",
      position: "relative",
    });

    return { $ul, $viewport };
  }

  function measureStepPx($dots) {
    // Prefer true step based on actual positions (accounts for gap)
    if ($dots.length >= 2) {
      const a = $dots.eq(0)[0].getBoundingClientRect().left;
      const b = $dots.eq(1)[0].getBoundingClientRect().left;
      const step = Math.round(b - a);
      if (step > 0) return step;
    }
    // Fallback: outerWidth
    const fallback = Math.round($dots.eq(0).outerWidth(true) || 20);
    return fallback;
  }

  function applyWindowAndAnimate(currentIndex) {
    // Defer to ensure Slick has laid out dots
    setTimeout(() => {
      const $dots = $slider.find(".slick-dots li");
      const totalDots = $dots.length;
      if (!totalDots) return;

      const pack = ensureDotsViewport();
      if (!pack) return;
      const { $ul, $viewport } = pack;

      // If total dots <= visibleCount, show all and reset transform/viewport width
      if (totalDots <= visibleCount) {
        $dots.each(function () {
          this.removeAttribute("aria-hidden");
          this.style.pointerEvents = "";
        });
        $ul.css({ transform: "translateX(0px)" });
        $viewport.css({ maxWidth: "none" });
        return;
      }

      // Clamp start index so we always display exactly "visibleCount" dots
      let startIndex = currentIndex;
      const lastStart = totalDots - visibleCount;
      if (startIndex > lastStart) startIndex = lastStart;
      if (startIndex < 0) startIndex = 0;

      // Make viewport width exactly fit 4 dots (with gaps)
      const stepPx = measureStepPx($dots);
      const viewportPx = stepPx * visibleCount - 8; // subtract last gap approximation
      $viewport.css({ maxWidth: viewportPx + "px" });

      // Accessibility / click safety: only window dots interactive
      $dots.each(function (i) {
        if (i >= startIndex && i < startIndex + visibleCount) {
          this.removeAttribute("aria-hidden");
          this.style.pointerEvents = "";
        } else {
          this.setAttribute("aria-hidden", "true");
          this.style.pointerEvents = "none";
        }
      });

      // ✅ Animate: slide UL so the startIndex dot sits at the left edge
      const targetLeft = $dots.eq(startIndex)[0].offsetLeft;
      $ul.css({ transform: `translateX(${-targetLeft}px)` });
    }, 0);
  }

  $slider.on("init.cmplDots afterChange.cmplDots", function (event, slick, currentSlide) {
    const index =
      typeof currentSlide === "number"
        ? currentSlide
        : slick && typeof slick.currentSlide === "number"
        ? slick.currentSlide
        : 0;

    applyWindowAndAnimate(index);
  });

  // If already initialized, apply immediately
  if ($slider.hasClass("slick-initialized")) {
    const slickObj = $slider.slick("getSlick");
    const idx = slickObj && typeof slickObj.currentSlide === "number" ? slickObj.currentSlide : 0;
    applyWindowAndAnimate(idx);
  }
}


const icon__option = {
  10000: {
    slidesToShow: 6,
    slidesToScroll: 2,
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
  },
  1200: {
    slidesToShow: 4,
    slidesToScroll: 2,
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2500,
  },
  650: {
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2500,
  },
};
const siwr__option = {
  10000: {
    slidesToShow: 2,
    slidesToScroll: 2,
    dots: true,
    arrows: false,
    infinite: true,
  },
  1200: {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
  },
};

const testimonials__option = {
  10000: {
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: true,
    arrows: false,
    infinite: false,
  },
  992: {
    slidesToShow: 2,
    slidesToScroll: 2,
    dots: true,
    arrows: false,
    infinite: false,
  },
  650: {
    slidesToShow: 1.7,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    infinite: false,
  },
  400: {
    slidesToShow: 1.3,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    infinite: false,
  },
};

const collection__option = {
  10000: {
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    infinite: false,
  },
  992: {
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    infinite: false,
  },
  650: {
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    infinite: false,
  },
  400: {
    slidesToShow: 1.5,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    infinite: false,
  },
};

const wwd__option = {
  992: {
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    adaptiveHeight: true,
  },
  650: {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    adaptiveHeight: true,
  },
};

const team__option = {
  10000: {
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
  },
  650: {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
  },
};

// ✅ FIX: cmpl-slider should only init on max-width 991px (not 992)
const cmpl__option = {
  991: {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
  },
};

const videos__option = {
  650: {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
  },
};

const iconBlocksSlider = new ResponsiveSlick(".icon-slider", icon__option);
const siwrSlider = new ResponsiveSlick(".siwr-slider", siwr__option);
const testimonialsSlider = new ResponsiveSlick(
  ".testimonials-slider",
  testimonials__option
);
const collectionSlider = new ResponsiveSlick(
  ".collection-slider",
  collection__option
);
const wwdSlider = new ResponsiveSlick(".wwd-slider", wwd__option);
const teamSlider = new ResponsiveSlick(".team-slider", team__option);
const videosSlider = new ResponsiveSlick(".videos-slider", videos__option);
const cmplSlider = new ResponsiveSlick(".cmpl-slider", cmpl__option);

// acccordion start
(function Accordion() {
  const triggers = document.querySelectorAll('[data-toggle="collapse"]');
  let activeToggle;
  triggers &&
    triggers.forEach((trigger) => {
      trigger.collapseTarget = document.querySelector(
        trigger.hash || trigger.dataset.target
      );

      trigger.collapseTarget.dataset.parent &&
        trigger.collapseTarget.classList.contains("is-active") &&
        (activeToggle = trigger);

      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        toggle(trigger);
      });

      // Remove height when end open transition
      trigger.collapseTarget.addEventListener("transitionend", ({ target }) => {
        if (!target.classList.contains("is-active")) return;

        target.style.height = null;
      });
    });
  function toggle(trigger) {
    if (trigger.collapseTarget.classList.contains("is-active")) {
      close(trigger);
      activeToggle = null;
    } else {
      activeToggle &&
        activeToggle.collapseTarget.dataset.parent &&
        close(activeToggle);

      trigger.collapseTarget.dataset.parent && (activeToggle = trigger);

      open(trigger);
    }
  }
  function close(trigger) {
    setHeight(trigger.collapseTarget);

    trigger.parentElement.classList.remove("is-active");
    trigger.classList.remove("is-active");
    trigger.collapseTarget.classList.remove("is-active");

    setTimeout(() => {
      trigger.collapseTarget.style.height = null;
    }, 0);
  }
  function open(trigger) {
    trigger.classList.add("is-active");
    trigger.parentElement.classList.add("is-active");

    setTimeout(() => {
      setHeight(trigger.collapseTarget);
      trigger.collapseTarget.classList.add("is-active");
    }, 0);
  }
  function setHeight(target) {
    target.style.height = target.scrollHeight + "px";
  }
})();

if ($(".featured-product-slider").length > 0) {
  jQuery(".featured-product-slider").slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: false,
    dots: true,
    arrows: true,
    infinite: true,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          autoplay: false,
          adaptiveHeight: true,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
}

if ($(".pss-slider").length > 0) {
  jQuery(".pss-slider").slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: true,
    arrows: true,
    infinite: true,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
        },
      },
    ],
  });
}

if (jQuery(".product-review-slider").length > 0) {
  jQuery(".product-review-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: true,
    centerMode: false,
    autoplay: false,
    adaptiveHeight: true,
    autoplaySpeed: 2000,
    speed: 500,
  });
}
$(document).ready(function () {
  $(".tab-item-link").on("click", function () {
    $(".featured-product-slider").slick("refresh");
  });
});

// $('.product__image-slider').slick({
//  slidesToShow: 1,
//  slidesToScroll: 1,
//  arrows: true,
//  dots: true,
//  infinite: false,
//  autoplay: false,
// });

$(".sbbr-slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: true,
  infinite: true,
  autoplay: false,
  adaptiveHeight: true,
});

$(".bfs-slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: true,
  infinite: true,
  autoplay: false,
  adaptiveHeight: true,
});
